import { Link } from "react-router-dom";

const features = [
  { icon: "ri-search-eye-line", title: "精准筛选", desc: "按类型、年份与热度组合筛选，快速定位想看的伦理影视。" },
  { icon: "ri-bookmark-3-line", title: "收藏心愿单", desc: "收藏喜欢的影片，随时回到想看的清单（本地演示保存）。" },
  { icon: "ri-play-circle-line", title: "在线播放演示", desc: "内置模拟播放器，体验剧集切换与播放交互流程。" },
];

export default function SiteIntro() {
  return (
    <section className="w-full px-4 pt-12 md:px-8">
      <div className="overflow-hidden rounded-lg border border-background-200/70 bg-background-100">
        <div className="grid grid-cols-1 gap-8 p-6 lg:grid-cols-2 lg:p-10">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950">关于伦理影院</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              伦理影院专注于伦理题材影视剧的内容聚合与浏览体验。我们整理了涵盖正义、家庭、都市与情感等多个议题的影视作品，
              通过清晰的分类、多维筛选和贴心推荐，帮助每一位观众更轻松地发现打动人心的伦理故事。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              平台以理性与温度并重为理念，既保证内容的条理清晰，也营造舒适的观影氛围。无论你是想重温经典，还是寻找新片，
              都能在这里找到属于自己的那一部。
            </p>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              了解更多 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
            {features.map((f) => (
              <div key={f.title} className="rounded-lg border border-background-200/70 bg-background-50 p-4">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                  <i className={`${f.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{f.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}